module.exports = __webpack_public_path__ + "img/PC_01.5bf8fb79.jpg";